import { type StyledComponentProps, useStyledSystem } from "@hopper-ui/components";
import { clsx } from "clsx";
import type { Ref } from "react";
import {
    GridList as RACGridList,
    GridListItem as RACGridListItem,
    type GridListItemProps as RACGridListItemProps,
    type GridListProps as RACGridListProps,
    composeRenderProps
} from "react-aria-components";

export type GridListProps<T> = StyledComponentProps<RACGridListProps<T>> & { ref?: Ref<HTMLDivElement> };
export const GridList = <T extends object>(props: GridListProps<T>) => {
    const { stylingProps, children, className, style, ...otherProps } = useStyledSystem(props);

    const classNames = clsx(stylingProps.className, className);
    const mergedStyles = composeRenderProps(style, prev => ({ ...stylingProps.style, ...prev }));

    return (
        <RACGridList style={mergedStyles} className={classNames} {...otherProps}>
            {children}
        </RACGridList>
    );
};

export type GridListItemProps = StyledComponentProps<RACGridListItemProps>;
export const GridListItem = (props: GridListItemProps) => {
    const { stylingProps, children, className, style, ...otherProps } = useStyledSystem(props);

    const classNames = clsx(stylingProps.className, className);
    const mergedStyles = composeRenderProps(style, prev => ({ ...stylingProps.style, ...prev }));

    return (
        <RACGridListItem style={mergedStyles} className={classNames} {...otherProps}>
            {children}
        </RACGridListItem>
    );
};
